export default "__VITE_ASSET__42cc1f28__"